import { LogViewer } from '@backstage/core-components';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Zoom from '@material-ui/core/Zoom';
import { makeStyles } from '@material-ui/core/styles';
import DescriptionIcon from '@material-ui/icons/Description';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { getProjectNameFromEntity } from '../getProjectNameFromEntity.esm.js';
import { useDownloadWorkflowRunLogs } from './useDownloadWorkflowRunLogs.esm.js';
import { getHostnameFromEntity } from '../getHostnameFromEntity.esm.js';

const useStyles = makeStyles((theme) => ({
  button: {
    order: -1,
    marginRight: 0,
    marginLeft: "-20px"
  },
  modal: {
    display: "flex",
    alignItems: "center",
    width: "85%",
    height: "85%",
    justifyContent: "center",
    margin: "auto"
  },
  normalLogContainer: {
    height: "75vh",
    width: "100%"
  },
  modalLogContainer: {
    height: "100%",
    width: "100%"
  },
  log: {
    background: theme.palette.background.default
  }
}));
const WorkflowRunLogs = ({
  entity,
  runId,
  inProgress
}) => {
  const classes = useStyles();
  const projectName = getProjectNameFromEntity(entity);
  const hostname = getHostnameFromEntity(entity);
  const [owner, repo] = projectName && projectName.split("/") || [];
  const jobLogs = useDownloadWorkflowRunLogs({
    hostname,
    owner,
    repo,
    id: runId
  });
  const logText = jobLogs.value ? String(jobLogs.value) : void 0;
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return /* @__PURE__ */ React.createElement(Accordion, { TransitionProps: { unmountOnExit: true }, disabled: inProgress }, /* @__PURE__ */ React.createElement(
    AccordionSummary,
    {
      expandIcon: /* @__PURE__ */ React.createElement(ExpandMoreIcon, null),
      IconButtonProps: {
        className: classes.button
      }
    },
    /* @__PURE__ */ React.createElement(Typography, { variant: "button" }, jobLogs.loading ? /* @__PURE__ */ React.createElement(CircularProgress, null) : "Job Log"),
    /* @__PURE__ */ React.createElement(Tooltip, { title: "Open Log", TransitionComponent: Zoom, arrow: true }, /* @__PURE__ */ React.createElement(
      DescriptionIcon,
      {
        onClick: (event) => {
          event.stopPropagation();
          handleOpen();
        },
        style: { marginLeft: "auto" }
      }
    )),
    /* @__PURE__ */ React.createElement(
      Modal,
      {
        className: classes.modal,
        onClick: (event) => event.stopPropagation(),
        open,
        onClose: handleClose
      },
      /* @__PURE__ */ React.createElement(Fade, { in: open }, /* @__PURE__ */ React.createElement("div", { className: classes.modalLogContainer }, /* @__PURE__ */ React.createElement(
        LogViewer,
        {
          text: logText ?? "No Values Found",
          classes: { root: classes.log }
        }
      )))
    )
  ), logText && /* @__PURE__ */ React.createElement("div", { className: classes.normalLogContainer }, /* @__PURE__ */ React.createElement(LogViewer, { text: logText, classes: { root: classes.log } })));
};

export { WorkflowRunLogs };
//# sourceMappingURL=WorkflowRunLogs.esm.js.map
